module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div class=\"kind\">\n    ")
    ;  if (isRoot()) { 
    ; __append("\n    <div class=\"field\">\n        <div class=\"title\">ID</div>\n        <div>\n            ")
    ; __append(escapeFn( item.id ))
    ; __append("\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n    <div class=\"field\">\n        <div class=\"title\">Время создания</div>\n        <div class=\"value\">\n            ")
    ; __append(escapeFn( item.createddatetime ? moment(item.createddatetime, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') : '' ))
    ; __append("\n        </div>\n    </div>\n    <div class=\"field\">\n        <div class=\"title\">Имя</div>\n        <div class=\"value\">\n            <div\n                data-control-type=\"text\"\n                data-control-target=\"item.name\"\n            >\n                ")
    ; __append(escapeFn( item.name ))
    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"field\">\n        <div class=\"title\">Описание</div>\n        <div class=\"value\">\n            <div\n                data-control-type=\"text-area\"\n                data-control-target=\"item.description\"\n            >\n                ")
    ; __append(escapeFn( item.description ))
    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"field\">\n        <div class=\"title\">Служебный</div>\n        <div class=\"value\">\n            <div\n                data-control-type=\"checkbox\"\n                data-control-target=\"item.service\"\n            >\n                ")
    ; __append(escapeFn( YesNo.title(item.service) ))
    ; __append("\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}